import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export function KPICard({ label, value, sub, icon: Icon, tone = 'default', testId }) {
  const tones = {
    default: 'bg-primary/10 text-primary',
    success: 'bg-emerald-100 text-emerald-700',
    warning: 'bg-amber-100 text-amber-700',
    info: 'bg-sky-100 text-sky-700',
    danger: 'bg-rose-100 text-rose-700',
  };
  return (
    <Card data-testid={testId || 'kpi-card'} className="border shadow-sm">
      <CardContent className="p-5">
        <div className="flex items-center justify-between">
          <div className="text-xs text-muted-foreground uppercase tracking-wide">{label}</div>
          {Icon && <div className={`h-9 w-9 rounded-lg ${tones[tone]} flex items-center justify-center`}><Icon className="h-5 w-5" /></div>}
        </div>
        <div className="mt-2 text-3xl font-heading font-semibold tabular-nums" data-testid="kpi-card-value">{value}</div>
        {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
      </CardContent>
    </Card>
  );
}

export default KPICard;
